export class GooglePayKeyState {}
